import styled from 'styled-components';

export const StyledCardContainer = styled.div<{
  overflow: string;
  padding?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  min-height: fit-content;
  padding: ${({ padding }) => padding ?? '24px'};

  border-radius: 12px;
  background-color: #fff;
  overflow: overflow;

  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);


  h2 {
    display: flex;
    align-items: center;

    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: #4D4C4D;

    margin-bottom: 24px;
  }

  h3 {
    display: flex;
    align-items: center;

    font-weight: 400;
    font-size: 16px;
    line-height: 23px;

    color: #424242;

    margin-top: 8px;
    margin-bottom: 15px;
    margin-left: 24px;

    margin: 24px 0 15px;
  }

  .styled-radio-button:not(:last-of-type) {
    margin-bottom: 14px;
  }
`;
